<div class="parameter-container">
  <div class="header-container" [ngClass]="{ open: showFilter }">
    <button mat-flat-button color="primary" class="show-filter-button" *ngIf="!showFilter" (click)="showFilter = true">
      {{'devices.detail.parameters.show-filters' | translate}}
    </button>
    <button mat-flat-button class="show-filter-button" *ngIf="showFilter" (click)="showFilter = false">
      {{'devices.detail.parameters.hide-filters' | translate}}
    </button>
    <div class="modify">
      <button mat-flat-button color="primary" class="header-button" (click)="onCancelClick()" *ngIf="modifyMode">
        {{'button.cancel' | translate}}
      </button>
      <button mat-flat-button color="primary" class="header-button" [ngClass]="{ 'save-button': modifyMode }"
        (click)="onChangeClick()" [disabled]="!modifyEnabled">
        {{(modifyMode ? 'button.save' : 'button.modify') | translate}}
      </button>
    </div>
  </div>
  <div class="other-filter-container" [formGroup]="filters" [@slideInOut]="showFilter ? 1 : 0">
    <mat-form-field appearance="outline" class="search-filter"
      *ngIf="deviceParametersColumnsToggle.includes('parameterNumber')">
      <mat-label>{{'devices.detail.parameters.header.num' | translate}}</mat-label>
      <input matInput formControlName="parameterNumber">
      <button *ngIf="!emptyFilter('parameterNumber')" matSuffix mat-icon-button aria-label="Clear"
        (click)="clearFilter('parameterNumber', $event)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search-filter"
      *ngIf="deviceParametersColumnsToggle.includes('parameterValue')">
      <mat-label>{{'devices.detail.parameters.header.value' | translate}}</mat-label>
      <input matInput formControlName="parameterValue">
      <button *ngIf="!emptyFilter('parameterValue')" matSuffix mat-icon-button aria-label="Clear"
        (click)="clearFilter('parameterValue', $event)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search-filter"
      *ngIf="deviceParametersColumnsToggle.includes('lastChangedBy')">
      <mat-label>{{'devices.detail.parameters.header.last-changed' | translate}}</mat-label>
      <input matInput formControlName="lastChangedBy">
      <button *ngIf="!emptyFilter('lastChangedBy')" matSuffix mat-icon-button aria-label="Clear"
        (click)="clearFilter('lastChangedBy', $event)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search-filter"
      *ngIf="deviceParametersColumnsToggle.includes('lastUpdatedTimestamp')">
      <mat-label>{{'devices.detail.parameters.header.last-updated' | translate}}</mat-label>
      <mat-date-range-input [rangePicker]="lastUpdatedTimestampPicker">
        <input matStartDate formControlName="lastUpdatedTimestampStart"
          [placeholder]="'devices.detail.parameters.header.last-updated-start' | translate">
        <input matEndDate formControlName="lastUpdatedTimestampEnd"
          [placeholder]="'devices.detail.parameters.header.last-updated-end' | translate">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="lastUpdatedTimestampPicker"></mat-datepicker-toggle>
      <mat-date-range-picker #lastUpdatedTimestampPicker>
        <mat-datepicker-actions>
          <button mat-button matDateRangePickerCancel aria-label="Clear"
            (click)="clearFilter('lastUpdatedTimestampStart', $event); clearFilter('lastUpdatedTimestampEnd', $event)">
            {{ 'table.clear-label' | translate }}
          </button>
          <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
        </mat-datepicker-actions>
      </mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search-filter"
      *ngIf="deviceParametersColumnsToggle.includes('important')">
      <mat-label>{{'devices.detail.parameters.header.important' | translate}}</mat-label>
      <mat-select panelWidth="fit-content" name="important" formControlName="important">
        <mat-option value="">{{'devices.detail.parameters.filter.all' | translate}}</mat-option>
        <mat-option value="true">{{'devices.detail.parameters.filter.important-only' | translate}}</mat-option>
        <mat-option value="false">{{'devices.detail.parameters.filter.not-important' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="device-table-container">
    <table #deviceParametersTable="matSort" mat-table [dataSource]="deviceParameters" matSort aria-label="parameters">
      <ng-container matColumnDef="parameterNumber">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.parameters.header.num' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.parameterNumber}}</td>
      </ng-container>
      <ng-container matColumnDef="parameterValue">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.parameters.header.value' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.parameterValue}}</td>
      </ng-container>
      <ng-container matColumnDef="lastChangedBy">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.parameters.header.last-changed' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.lastChangedBy}}</td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.parameters.header.last-updated' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.lastUpdatedTimestamp | defaultDate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="important">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.parameters.header.important' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle color="primary" [disabled]="!modifying" [checked]="element.important"
            (change)="onImportantToggle($event, element)"></mat-slide-toggle>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="filteredDeviceParametersColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: filteredDeviceParametersColumns;"
        [ngClass]="{'important-row': row.important }"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{ 'table.no-records' | translate }}</td>
      </tr>
    </table>
  </div>
  <mat-paginator #deviceParametersPaginator [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="!mobile"
    [hidePageSize]="mobile"></mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceParametersGroup="matButtonToggleGroup"
    [(ngModel)]="deviceParametersColumnsToggle" class="parameters-toggle">
    <mat-button-toggle value="parameterNumber" class="parameters-toggle-item">
      <span>{{'devices.detail.parameters.header.num' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="parameterValue" class="parameters-toggle-item">
      <span>{{'devices.detail.parameters.header.value' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastChangedBy" class="parameters-toggle-item">
      <span>{{'devices.detail.parameters.header.last-changed' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="parameters-toggle-item">
      <span>{{'devices.detail.parameters.header.last-updated' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="important" class="parameters-toggle-item">
      <span>{{'devices.detail.parameters.header.important' | translate}}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="loading-overlay" *ngIf="loading">
  <mat-progress-spinner mode="indeterminate" diameter="50">
  </mat-progress-spinner>
</div>